import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/nocturne.css';
import './styles/phosphor.css';
import './styles/app.css';
import { App } from './App';

// The local development copy looks identical to the live site; make it impossible to confuse the two.
const isLocal = ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isLocal && (
      <div role="status" style={{ position: 'sticky', top: 0, zIndex: 1000, background: '#b45309', color: '#fff', textAlign: 'center', fontSize: 13, fontWeight: 600, padding: '6px 12px' }}>
        LOCAL DEVELOPMENT COPY — changes here do not reach the live site (app.provenlab.tech)
      </div>
    )}
    <App />
  </StrictMode>,
);
